// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link from "./buhta_kassa_v1alpha1_etp_link.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm from "./buhta_kassa_v1alpha1_kkm.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info from "./buhta_kassa_v1alpha1_kkm_info.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const ListEtpOrgsRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  1740,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListEtpOrgsResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  1796,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListEtpKkmsRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  1857,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ListEtpKkmsResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  1920,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetEtpInfoRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  1978,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetEtpInfoResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2034,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetEtpLinkRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2095,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const GetEtpLinkResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2158,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateEtpLinkRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2251,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "EtpLinkData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const CreateEtpLinkResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2382,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const UpdateEtpLinkRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2474,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "EtpLinkData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const UpdateEtpLinkResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2601,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ResetEtpLinkRequest = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2661,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

const ResetEtpLinkResponse = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2719,
  12
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name(param) {
  return ".buhta.kassa.v1alpha1.ListEtpOrgsRequest";
}

function make(param) {
  
}

function merge(param, param$1) {
  
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p(writer, param) {
  Curry._1(serialize, writer);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize, writer);
  return writer;
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn, writer);
  });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListEtpOrgsRequest", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListEtpOrgsRequest", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListEtpOrgsRequest, {
  make: make,
  to_proto: to_proto,
  from_proto: from_proto,
  to_json: to_json,
  from_json: from_json,
  name: name,
  merge: merge,
  to_proto$p: to_proto$p,
  from_proto_exn: from_proto_exn,
  from_json_exn: from_json_exn
});

function name$1(param) {
  return ".buhta.kassa.v1alpha1.ListEtpOrgsResponse";
}

function make$1(orgsOpt, param) {
  const orgs = orgsOpt !== undefined ? orgsOpt : /* [] */ 0;
  return {
    orgs: orgs
  };
}

const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info.Buhta.Kassa.V1alpha1.OrgInfo;

const merge_orgs = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "orgs",
    "orgs"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let.name,
    make: $$let.make,
    from_proto: $$let.from_proto,
    from_proto_exn: $$let.from_proto_exn,
    to_proto: $$let.to_proto,
    to_proto$p: $$let.to_proto$p,
    merge: $$let.merge,
    to_json: $$let.to_json,
    from_json_exn: $$let.from_json_exn,
    from_json: $$let.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$1(t1, t2) {
  return {
    orgs: Curry._2(merge_orgs, t1.orgs, t2.orgs)
  };
}

function spec(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm_info.Buhta.Kassa.V1alpha1.OrgInfo;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "orgs",
      "orgs"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
});

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.orgs);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor(orgs) {
  return {
    orgs: orgs
  };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
});

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$1, writer);
  });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListEtpOrgsResponse", spec(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.orgs);
  };
}

function constructor$1(orgs) {
  return {
    orgs: orgs
  };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListEtpOrgsResponse", spec(undefined), constructor$1);
});

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$1, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListEtpOrgsResponse, {
  make: make$1,
  to_proto: to_proto$1,
  from_proto: from_proto$1,
  to_json: to_json$1,
  from_json: from_json$1,
  name: name$1,
  merge: merge$1,
  to_proto$p: to_proto$p$1,
  from_proto_exn: from_proto_exn$1,
  from_json_exn: from_json_exn$1
});

function name$2(param) {
  return ".buhta.kassa.v1alpha1.ListEtpKkmsRequest";
}

function make$2(tinOpt, grid, param) {
  const tin = tinOpt !== undefined ? tinOpt : "";
  return {
    tin: tin,
    grid: grid
  };
}

const merge_tin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "tin",
    "tin"
  ],
  Ocaml_protoc_plugin__Spec.string,
  ""
]));

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    3,
    "grid",
    "grid"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$1.name,
    make: $$let$1.make,
    from_proto: $$let$1.from_proto,
    from_proto_exn: $$let$1.from_proto_exn,
    to_proto: $$let$1.to_proto,
    to_proto$p: $$let$1.to_proto$p,
    merge: $$let$1.merge,
    to_json: $$let$1.to_json,
    from_json_exn: $$let$1.from_json_exn,
    from_json: $$let$1.from_json
  })
]));

function merge$2(t1, t2) {
  return {
    tin: Curry._2(merge_tin, t1.tin, t2.tin),
    grid: Curry._2(merge_grid, t1.grid, t2.grid)
  };
}

function spec$1(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "tin",
      "tin"
    ],
    Ocaml_protoc_plugin__Spec.string,
    ""
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      3,
      "grid",
      "grid"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
});

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.tin, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$2(tin, grid) {
  return {
    tin: tin,
    grid: grid
  };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
});

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$2, writer);
  });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListEtpKkmsRequest", spec$1(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.tin, param.grid);
  };
}

function constructor$3(tin, grid) {
  return {
    tin: tin,
    grid: grid
  };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListEtpKkmsRequest", spec$1(undefined), constructor$3);
});

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$2, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListEtpKkmsRequest, {
  make: make$2,
  to_proto: to_proto$2,
  from_proto: from_proto$2,
  to_json: to_json$2,
  from_json: from_json$2,
  name: name$2,
  merge: merge$2,
  to_proto$p: to_proto$p$2,
  from_proto_exn: from_proto_exn$2,
  from_json_exn: from_json_exn$2
});

function name$3(param) {
  return ".buhta.kassa.v1alpha1.ListEtpKkmsResponse";
}

function make$3(kkmsOpt, param) {
  const kkms = kkmsOpt !== undefined ? kkmsOpt : /* [] */ 0;
  return {
    kkms: kkms
  };
}

const $$let$2 = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;

const merge_kkms = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    1,
    "kkms",
    "kkms"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$2.name,
    make: $$let$2.make,
    from_proto: $$let$2.from_proto,
    from_proto_exn: $$let$2.from_proto_exn,
    to_proto: $$let$2.to_proto,
    to_proto$p: $$let$2.to_proto$p,
    merge: $$let$2.merge,
    to_json: $$let$2.to_json,
    from_json_exn: $$let$2.from_json_exn,
    from_json: $$let$2.from_json
  }),
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$3(t1, t2) {
  return {
    kkms: Curry._2(merge_kkms, t1.kkms, t2.kkms)
  };
}

function spec$2(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_kkm.Buhta.Kassa.V1alpha1.Kkm;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      1,
      "kkms",
      "kkms"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    }),
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
});

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.kkms);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$4(kkms) {
  return {
    kkms: kkms
  };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
});

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$3, writer);
  });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListEtpKkmsResponse", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkms);
  };
}

function constructor$5(kkms) {
  return {
    kkms: kkms
  };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListEtpKkmsResponse", spec$2(undefined), constructor$5);
});

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$3, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ListEtpKkmsResponse, {
  make: make$3,
  to_proto: to_proto$3,
  from_proto: from_proto$3,
  to_json: to_json$3,
  from_json: from_json$3,
  name: name$3,
  merge: merge$3,
  to_proto$p: to_proto$p$3,
  from_proto_exn: from_proto_exn$3,
  from_json_exn: from_json_exn$3
});

function name$4(param) {
  return ".buhta.kassa.v1alpha1.GetEtpInfoRequest";
}

function make$4(param) {
  
}

function merge$4(param, param$1) {
  
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p$4(writer, param) {
  Curry._1(serialize$4, writer);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$4, writer);
  return writer;
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn$4, writer);
  });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetEtpInfoRequest", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetEtpInfoRequest", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn$4, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetEtpInfoRequest, {
  make: make$4,
  to_proto: to_proto$4,
  from_proto: from_proto$4,
  to_json: to_json$4,
  from_json: from_json$4,
  name: name$4,
  merge: merge$4,
  to_proto$p: to_proto$p$4,
  from_proto_exn: from_proto_exn$4,
  from_json_exn: from_json_exn$4
});

function name$5(param) {
  return ".buhta.kassa.v1alpha1.GetEtpInfoResponse";
}

function make$5(etp, param) {
  return {
    etp: etp
  };
}

const $$let$3 = Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link.Buhta.Kassa.V1alpha1.EtpInfo;

const merge_etp = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "etp",
    "etp"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$3.name,
    make: $$let$3.make,
    from_proto: $$let$3.from_proto,
    from_proto_exn: $$let$3.from_proto_exn,
    to_proto: $$let$3.to_proto,
    to_proto$p: $$let$3.to_proto$p,
    merge: $$let$3.merge,
    to_json: $$let$3.to_json,
    from_json_exn: $$let$3.from_json_exn,
    from_json: $$let$3.from_json
  })
]));

function merge$5(t1, t2) {
  return {
    etp: Curry._2(merge_etp, t1.etp, t2.etp)
  };
}

function spec$3(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link.Buhta.Kassa.V1alpha1.EtpInfo;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "etp",
      "etp"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
});

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.etp);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$6(etp) {
  return {
    etp: etp
  };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
});

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$5, writer);
  });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetEtpInfoResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.etp);
  };
}

function constructor$7(etp) {
  return {
    etp: etp
  };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetEtpInfoResponse", spec$3(undefined), constructor$7);
});

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$5, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetEtpInfoResponse, {
  make: make$5,
  to_proto: to_proto$5,
  from_proto: from_proto$5,
  to_json: to_json$5,
  from_json: from_json$5,
  name: name$5,
  merge: merge$5,
  to_proto$p: to_proto$p$5,
  from_proto_exn: from_proto_exn$5,
  from_json_exn: from_json_exn$5
});

function name$6(param) {
  return ".buhta.kassa.v1alpha1.GetEtpLinkRequest";
}

function make$6(idOpt, expandOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  return {
    id: id,
    expand: expand
  };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
  [
    2,
    "expand",
    "expand"
  ],
  Ocaml_protoc_plugin__Spec.string,
  Ocaml_protoc_plugin__Spec.not_packed
]));

function merge$6(t1, t2) {
  return {
    id: Curry._2(merge_id, t1.id, t2.id),
    expand: Curry._2(merge_expand, t1.expand, t2.expand)
  };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
    [
      2,
      "expand",
      "expand"
    ],
    Ocaml_protoc_plugin__Spec.string,
    Ocaml_protoc_plugin__Spec.not_packed
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
});

function to_proto$p$6(writer, param) {
  Curry._3(serialize$6, writer, param.id, param.expand);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$8(id, expand) {
  return {
    id: id,
    expand: expand
  };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
});

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$6, writer);
  });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetEtpLinkRequest", spec$4(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.expand);
  };
}

function constructor$9(id, expand) {
  return {
    id: id,
    expand: expand
  };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetEtpLinkRequest", spec$4(undefined), constructor$9);
});

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$6, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetEtpLinkRequest, {
  make: make$6,
  to_proto: to_proto$6,
  from_proto: from_proto$6,
  to_json: to_json$6,
  from_json: from_json$6,
  name: name$6,
  merge: merge$6,
  to_proto$p: to_proto$p$6,
  from_proto_exn: from_proto_exn$6,
  from_json_exn: from_json_exn$6
});

function name$7(param) {
  return ".buhta.kassa.v1alpha1.GetEtpLinkResponse";
}

function make$7(link, param) {
  return {
    link: link
  };
}

const $$let$4 = Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link.Buhta.Kassa.V1alpha1.EtpLink;

const merge_link = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "link",
    "link"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$4.name,
    make: $$let$4.make,
    from_proto: $$let$4.from_proto,
    from_proto_exn: $$let$4.from_proto_exn,
    to_proto: $$let$4.to_proto,
    to_proto$p: $$let$4.to_proto$p,
    merge: $$let$4.merge,
    to_json: $$let$4.to_json,
    from_json_exn: $$let$4.from_json_exn,
    from_json: $$let$4.from_json
  })
]));

function merge$7(t1, t2) {
  return {
    link: Curry._2(merge_link, t1.link, t2.link)
  };
}

function spec$5(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link.Buhta.Kassa.V1alpha1.EtpLink;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "link",
      "link"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
});

function to_proto$p$7(writer, param) {
  Curry._2(serialize$7, writer, param.link);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$10(link) {
  return {
    link: link
  };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
});

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$7, writer);
  });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetEtpLinkResponse", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.link);
  };
}

function constructor$11(link) {
  return {
    link: link
  };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetEtpLinkResponse", spec$5(undefined), constructor$11);
});

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$7, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, GetEtpLinkResponse, {
  make: make$7,
  to_proto: to_proto$7,
  from_proto: from_proto$7,
  to_json: to_json$7,
  from_json: from_json$7,
  name: name$7,
  merge: merge$7,
  to_proto$p: to_proto$p$7,
  from_proto_exn: from_proto_exn$7,
  from_json_exn: from_json_exn$7
});

const EtpLinkData = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2284,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$8(param) {
  return ".buhta.kassa.v1alpha1.CreateEtpLinkRequest.EtpLinkData";
}

function make$8(etp_idOpt, allow_ingressOpt, allow_egressOpt, param) {
  const etp_id = etp_idOpt !== undefined ? etp_idOpt : 0;
  const allow_ingress = allow_ingressOpt !== undefined ? allow_ingressOpt : false;
  const allow_egress = allow_egressOpt !== undefined ? allow_egressOpt : false;
  return {
    etp_id: etp_id,
    allow_ingress: allow_ingress,
    allow_egress: allow_egress
  };
}

const merge_etp_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "etp_id",
    "etpId"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_allow_ingress = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "allow_ingress",
    "allowIngress"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_egress = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    3,
    "allow_egress",
    "allowEgress"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

function merge$8(t1, t2) {
  return {
    etp_id: Curry._2(merge_etp_id, t1.etp_id, t2.etp_id),
    allow_ingress: Curry._2(merge_allow_ingress, t1.allow_ingress, t2.allow_ingress),
    allow_egress: Curry._2(merge_allow_egress, t1.allow_egress, t2.allow_egress)
  };
}

function spec$6(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "etp_id",
      "etpId"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "allow_ingress",
      "allowIngress"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      3,
      "allow_egress",
      "allowEgress"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
});

function to_proto$p$8(writer, param) {
  Curry._4(serialize$8, writer, param.etp_id, param.allow_ingress, param.allow_egress);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$12(etp_id, allow_ingress, allow_egress) {
  return {
    etp_id: etp_id,
    allow_ingress: allow_ingress,
    allow_egress: allow_egress
  };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
});

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$8, writer);
  });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateEtpLinkRequest.EtpLinkData", spec$6(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.etp_id, param.allow_ingress, param.allow_egress);
  };
}

function constructor$13(etp_id, allow_ingress, allow_egress) {
  return {
    etp_id: etp_id,
    allow_ingress: allow_ingress,
    allow_egress: allow_egress
  };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateEtpLinkRequest.EtpLinkData", spec$6(undefined), constructor$13);
});

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$8, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, EtpLinkData, {
  make: make$8,
  to_proto: to_proto$8,
  from_proto: from_proto$8,
  to_json: to_json$8,
  from_json: from_json$8,
  name: name$8,
  merge: merge$8,
  to_proto$p: to_proto$p$8,
  from_proto_exn: from_proto_exn$8,
  from_json_exn: from_json_exn$8
});

function name$9(param) {
  return ".buhta.kassa.v1alpha1.CreateEtpLinkRequest";
}

function make$9(idOpt, link, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id,
    link: link
  };
}

const merge_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_link$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "link",
    "link"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: EtpLinkData.name,
    make: EtpLinkData.make,
    from_proto: EtpLinkData.from_proto,
    from_proto_exn: EtpLinkData.from_proto_exn,
    to_proto: EtpLinkData.to_proto,
    to_proto$p: EtpLinkData.to_proto$p,
    merge: EtpLinkData.merge,
    to_json: EtpLinkData.to_json,
    from_json_exn: EtpLinkData.from_json_exn,
    from_json: EtpLinkData.from_json
  })
]));

function merge$9(t1, t2) {
  return {
    id: Curry._2(merge_id$1, t1.id, t2.id),
    link: Curry._2(merge_link$1, t1.link, t2.link)
  };
}

function spec$7(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "link",
      "link"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: EtpLinkData.name,
      make: EtpLinkData.make,
      from_proto: EtpLinkData.from_proto,
      from_proto_exn: EtpLinkData.from_proto_exn,
      to_proto: EtpLinkData.to_proto,
      to_proto$p: EtpLinkData.to_proto$p,
      merge: EtpLinkData.merge,
      to_json: EtpLinkData.to_json,
      from_json_exn: EtpLinkData.from_json_exn,
      from_json: EtpLinkData.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
});

function to_proto$p$9(writer, param) {
  Curry._3(serialize$9, writer, param.id, param.link);
}

function to_proto$9(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$9(writer, t);
  return writer;
}

function constructor$14(id, link) {
  return {
    id: id,
    link: link
  };
}

const from_proto_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
});

function from_proto$9(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$9, writer);
  });
}

function to_json$9(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateEtpLinkRequest", spec$7(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.link);
  };
}

function constructor$15(id, link) {
  return {
    id: id,
    link: link
  };
}

const from_json_exn$9 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateEtpLinkRequest", spec$7(undefined), constructor$15);
});

function from_json$9(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$9, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "EtpLinkData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateEtpLinkRequest, {
  EtpLinkData: EtpLinkData,
  make: make$9,
  to_proto: to_proto$9,
  from_proto: from_proto$9,
  to_json: to_json$9,
  from_json: from_json$9,
  name: name$9,
  merge: merge$9,
  to_proto$p: to_proto$p$9,
  from_proto_exn: from_proto_exn$9,
  from_json_exn: from_json_exn$9
});

function name$10(param) {
  return ".buhta.kassa.v1alpha1.CreateEtpLinkResponse";
}

function make$10(link, param) {
  return {
    link: link
  };
}

const $$let$5 = Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link.Buhta.Kassa.V1alpha1.EtpLink;

const merge_link$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "link",
    "link"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$5.name,
    make: $$let$5.make,
    from_proto: $$let$5.from_proto,
    from_proto_exn: $$let$5.from_proto_exn,
    to_proto: $$let$5.to_proto,
    to_proto$p: $$let$5.to_proto$p,
    merge: $$let$5.merge,
    to_json: $$let$5.to_json,
    from_json_exn: $$let$5.from_json_exn,
    from_json: $$let$5.from_json
  })
]));

function merge$10(t1, t2) {
  return {
    link: Curry._2(merge_link$2, t1.link, t2.link)
  };
}

function spec$8(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link.Buhta.Kassa.V1alpha1.EtpLink;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "link",
      "link"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
});

function to_proto$p$10(writer, param) {
  Curry._2(serialize$10, writer, param.link);
}

function to_proto$10(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$10(writer, t);
  return writer;
}

function constructor$16(link) {
  return {
    link: link
  };
}

const from_proto_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
});

function from_proto$10(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$10, writer);
  });
}

function to_json$10(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateEtpLinkResponse", spec$8(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.link);
  };
}

function constructor$17(link) {
  return {
    link: link
  };
}

const from_json_exn$10 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateEtpLinkResponse", spec$8(undefined), constructor$17);
});

function from_json$10(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$10, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, CreateEtpLinkResponse, {
  make: make$10,
  to_proto: to_proto$10,
  from_proto: from_proto$10,
  to_json: to_json$10,
  from_json: from_json$10,
  name: name$10,
  merge: merge$10,
  to_proto$p: to_proto$p$10,
  from_proto_exn: from_proto_exn$10,
  from_json_exn: from_json_exn$10
});

const EtpLinkData$1 = Caml_module.init_mod([
  "proto/kassaapis/gen/buhta_kassa_v1alpha1_kkm_etp_service.ml",
  2506,
  14
], {
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
});

function name$11(param) {
  return ".buhta.kassa.v1alpha1.UpdateEtpLinkRequest.EtpLinkData";
}

function make$11(allow_ingressOpt, allow_egressOpt, param) {
  const allow_ingress = allow_ingressOpt !== undefined ? allow_ingressOpt : false;
  const allow_egress = allow_egressOpt !== undefined ? allow_egressOpt : false;
  return {
    allow_ingress: allow_ingress,
    allow_egress: allow_egress
  };
}

const merge_allow_ingress$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "allow_ingress",
    "allowIngress"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

const merge_allow_egress$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    2,
    "allow_egress",
    "allowEgress"
  ],
  Ocaml_protoc_plugin__Spec.bool,
  false
]));

function merge$11(t1, t2) {
  return {
    allow_ingress: Curry._2(merge_allow_ingress$1, t1.allow_ingress, t2.allow_ingress),
    allow_egress: Curry._2(merge_allow_egress$1, t1.allow_egress, t2.allow_egress)
  };
}

function spec$9(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "allow_ingress",
      "allowIngress"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      2,
      "allow_egress",
      "allowEgress"
    ],
    Ocaml_protoc_plugin__Spec.bool,
    false
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$9(undefined));
});

function to_proto$p$11(writer, param) {
  Curry._3(serialize$11, writer, param.allow_ingress, param.allow_egress);
}

function to_proto$11(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$11(writer, t);
  return writer;
}

function constructor$18(allow_ingress, allow_egress) {
  return {
    allow_ingress: allow_ingress,
    allow_egress: allow_egress
  };
}

const from_proto_exn$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$9(undefined), constructor$18);
});

function from_proto$11(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$11, writer);
  });
}

function to_json$11(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.UpdateEtpLinkRequest.EtpLinkData", spec$9(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.allow_ingress, param.allow_egress);
  };
}

function constructor$19(allow_ingress, allow_egress) {
  return {
    allow_ingress: allow_ingress,
    allow_egress: allow_egress
  };
}

const from_json_exn$11 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.UpdateEtpLinkRequest.EtpLinkData", spec$9(undefined), constructor$19);
});

function from_json$11(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$11, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, EtpLinkData$1, {
  make: make$11,
  to_proto: to_proto$11,
  from_proto: from_proto$11,
  to_json: to_json$11,
  from_json: from_json$11,
  name: name$11,
  merge: merge$11,
  to_proto$p: to_proto$p$11,
  from_proto_exn: from_proto_exn$11,
  from_json_exn: from_json_exn$11
});

function name$12(param) {
  return ".buhta.kassa.v1alpha1.UpdateEtpLinkRequest";
}

function make$12(idOpt, link, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id,
    link: link
  };
}

const merge_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

const merge_link$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    2,
    "link",
    "link"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: EtpLinkData$1.name,
    make: EtpLinkData$1.make,
    from_proto: EtpLinkData$1.from_proto,
    from_proto_exn: EtpLinkData$1.from_proto_exn,
    to_proto: EtpLinkData$1.to_proto,
    to_proto$p: EtpLinkData$1.to_proto$p,
    merge: EtpLinkData$1.merge,
    to_json: EtpLinkData$1.to_json,
    from_json_exn: EtpLinkData$1.from_json_exn,
    from_json: EtpLinkData$1.from_json
  })
]));

function merge$12(t1, t2) {
  return {
    id: Curry._2(merge_id$2, t1.id, t2.id),
    link: Curry._2(merge_link$3, t1.link, t2.link)
  };
}

function spec$10(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      2,
      "link",
      "link"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: EtpLinkData$1.name,
      make: EtpLinkData$1.make,
      from_proto: EtpLinkData$1.from_proto,
      from_proto_exn: EtpLinkData$1.from_proto_exn,
      to_proto: EtpLinkData$1.to_proto,
      to_proto$p: EtpLinkData$1.to_proto$p,
      merge: EtpLinkData$1.merge,
      to_json: EtpLinkData$1.to_json,
      from_json_exn: EtpLinkData$1.from_json_exn,
      from_json: EtpLinkData$1.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$10(undefined));
});

function to_proto$p$12(writer, param) {
  Curry._3(serialize$12, writer, param.id, param.link);
}

function to_proto$12(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$12(writer, t);
  return writer;
}

function constructor$20(id, link) {
  return {
    id: id,
    link: link
  };
}

const from_proto_exn$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$10(undefined), constructor$20);
});

function from_proto$12(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$12, writer);
  });
}

function to_json$12(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.UpdateEtpLinkRequest", spec$10(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.id, param.link);
  };
}

function constructor$21(id, link) {
  return {
    id: id,
    link: link
  };
}

const from_json_exn$12 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.UpdateEtpLinkRequest", spec$10(undefined), constructor$21);
});

function from_json$12(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$12, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      {
        TAG: /* Module */ 0,
        _0: [
          [
            /* Function */ 0,
            "make"
          ],
          [
            /* Function */ 0,
            "to_proto"
          ],
          [
            /* Function */ 0,
            "from_proto"
          ],
          [
            /* Function */ 0,
            "to_json"
          ],
          [
            /* Function */ 0,
            "from_json"
          ],
          [
            /* Function */ 0,
            "name"
          ],
          [
            /* Function */ 0,
            "merge"
          ],
          [
            /* Function */ 0,
            "to_proto$p"
          ],
          [
            /* Function */ 0,
            "from_proto_exn"
          ],
          [
            /* Function */ 0,
            "from_json_exn"
          ]
        ]
      },
      "EtpLinkData"
    ],
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, UpdateEtpLinkRequest, {
  EtpLinkData: EtpLinkData$1,
  make: make$12,
  to_proto: to_proto$12,
  from_proto: from_proto$12,
  to_json: to_json$12,
  from_json: from_json$12,
  name: name$12,
  merge: merge$12,
  to_proto$p: to_proto$p$12,
  from_proto_exn: from_proto_exn$12,
  from_json_exn: from_json_exn$12
});

function name$13(param) {
  return ".buhta.kassa.v1alpha1.UpdateEtpLinkResponse";
}

function make$13(link, param) {
  return {
    link: link
  };
}

const $$let$6 = Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link.Buhta.Kassa.V1alpha1.EtpLink;

const merge_link$4 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
  [
    1,
    "link",
    "link"
  ],
  Ocaml_protoc_plugin__Spec.message({
    name: $$let$6.name,
    make: $$let$6.make,
    from_proto: $$let$6.from_proto,
    from_proto_exn: $$let$6.from_proto_exn,
    to_proto: $$let$6.to_proto,
    to_proto$p: $$let$6.to_proto$p,
    merge: $$let$6.merge,
    to_json: $$let$6.to_json,
    from_json_exn: $$let$6.from_json_exn,
    from_json: $$let$6.from_json
  })
]));

function merge$13(t1, t2) {
  return {
    link: Curry._2(merge_link$4, t1.link, t2.link)
  };
}

function spec$11(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_etp_link.Buhta.Kassa.V1alpha1.EtpLink;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
    [
      1,
      "link",
      "link"
    ],
    Ocaml_protoc_plugin__Spec.message({
      name: $$let.name,
      make: $$let.make,
      from_proto: $$let.from_proto,
      from_proto_exn: $$let.from_proto_exn,
      to_proto: $$let.to_proto,
      to_proto$p: $$let.to_proto$p,
      merge: $$let.merge,
      to_json: $$let.to_json,
      from_json_exn: $$let.from_json_exn,
      from_json: $$let.from_json
    })
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$11(undefined));
});

function to_proto$p$13(writer, param) {
  Curry._2(serialize$13, writer, param.link);
}

function to_proto$13(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$13(writer, t);
  return writer;
}

function constructor$22(link) {
  return {
    link: link
  };
}

const from_proto_exn$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$11(undefined), constructor$22);
});

function from_proto$13(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$13, writer);
  });
}

function to_json$13(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.UpdateEtpLinkResponse", spec$11(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.link);
  };
}

function constructor$23(link) {
  return {
    link: link
  };
}

const from_json_exn$13 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.UpdateEtpLinkResponse", spec$11(undefined), constructor$23);
});

function from_json$13(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$13, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, UpdateEtpLinkResponse, {
  make: make$13,
  to_proto: to_proto$13,
  from_proto: from_proto$13,
  to_json: to_json$13,
  from_json: from_json$13,
  name: name$13,
  merge: merge$13,
  to_proto$p: to_proto$p$13,
  from_proto_exn: from_proto_exn$13,
  from_json_exn: from_json_exn$13
});

function name$14(param) {
  return ".buhta.kassa.v1alpha1.ResetEtpLinkRequest";
}

function make$14(idOpt, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  return {
    id: id
  };
}

const merge_id$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
  [
    1,
    "id",
    "id"
  ],
  Ocaml_protoc_plugin__Spec.int32_int,
  0
]));

function merge$14(t1, t2) {
  return {
    id: Curry._2(merge_id$3, t1.id, t2.id)
  };
}

function spec$12(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
    [
      1,
      "id",
      "id"
    ],
    Ocaml_protoc_plugin__Spec.int32_int,
    0
  ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$14 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(spec$12(undefined));
});

function to_proto$p$14(writer, param) {
  Curry._2(serialize$14, writer, param.id);
}

function to_proto$14(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$14(writer, t);
  return writer;
}

function constructor$24(id) {
  return {
    id: id
  };
}

const from_proto_exn$14 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(spec$12(undefined), constructor$24);
});

function from_proto$14(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_proto_exn$14, writer);
  });
}

function to_json$14(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ResetEtpLinkRequest", spec$12(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.id);
  };
}

function constructor$25(id) {
  return {
    id: id
  };
}

const from_json_exn$14 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ResetEtpLinkRequest", spec$12(undefined), constructor$25);
});

function from_json$14(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    return Curry._1(from_json_exn$14, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ResetEtpLinkRequest, {
  make: make$14,
  to_proto: to_proto$14,
  from_proto: from_proto$14,
  to_json: to_json$14,
  from_json: from_json$14,
  name: name$14,
  merge: merge$14,
  to_proto$p: to_proto$p$14,
  from_proto_exn: from_proto_exn$14,
  from_json_exn: from_json_exn$14
});

function name$15(param) {
  return ".buhta.kassa.v1alpha1.ResetEtpLinkResponse";
}

function make$15(param) {
  
}

function merge$15(param, param$1) {
  
}

const serialize$15 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Serialize.serialize(Ocaml_protoc_plugin__Spec.nil);
});

function to_proto$p$15(writer, param) {
  Curry._1(serialize$15, writer);
}

function to_proto$15(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  Curry._1(serialize$15, writer);
  return writer;
}

const from_proto_exn$15 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize.deserialize(Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_proto$15(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_proto_exn$15, writer);
  });
}

function to_json$15(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ResetEtpLinkResponse", Ocaml_protoc_plugin__Spec.nil)(options);
  return function (param) {
    return serialize;
  };
}

const from_json_exn$15 = Ocaml_protoc_plugin.apply_lazy(function (param) {
  return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ResetEtpLinkResponse", Ocaml_protoc_plugin__Spec.nil, undefined);
});

function from_json$15(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
    Curry._1(from_json_exn$15, json);
  });
}

Caml_module.update_mod({
  TAG: /* Module */ 0,
  _0: [
    [
      /* Function */ 0,
      "make"
    ],
    [
      /* Function */ 0,
      "to_proto"
    ],
    [
      /* Function */ 0,
      "from_proto"
    ],
    [
      /* Function */ 0,
      "to_json"
    ],
    [
      /* Function */ 0,
      "from_json"
    ],
    [
      /* Function */ 0,
      "name"
    ],
    [
      /* Function */ 0,
      "merge"
    ],
    [
      /* Function */ 0,
      "to_proto$p"
    ],
    [
      /* Function */ 0,
      "from_proto_exn"
    ],
    [
      /* Function */ 0,
      "from_json_exn"
    ]
  ]
}, ResetEtpLinkResponse, {
  make: make$15,
  to_proto: to_proto$15,
  from_proto: from_proto$15,
  to_json: to_json$15,
  from_json: from_json$15,
  name: name$15,
  merge: merge$15,
  to_proto$p: to_proto$p$15,
  from_proto_exn: from_proto_exn$15,
  from_json_exn: from_json_exn$15
});

const listEtpOrgs_0 = {
  name: ListEtpOrgsRequest.name,
  make: ListEtpOrgsRequest.make,
  from_proto: ListEtpOrgsRequest.from_proto,
  from_proto_exn: ListEtpOrgsRequest.from_proto_exn,
  to_proto: ListEtpOrgsRequest.to_proto,
  to_proto$p: ListEtpOrgsRequest.to_proto$p,
  merge: ListEtpOrgsRequest.merge,
  to_json: ListEtpOrgsRequest.to_json,
  from_json_exn: ListEtpOrgsRequest.from_json_exn,
  from_json: ListEtpOrgsRequest.from_json
};

const listEtpOrgs_1 = {
  name: ListEtpOrgsResponse.name,
  make: ListEtpOrgsResponse.make,
  from_proto: ListEtpOrgsResponse.from_proto,
  from_proto_exn: ListEtpOrgsResponse.from_proto_exn,
  to_proto: ListEtpOrgsResponse.to_proto,
  to_proto$p: ListEtpOrgsResponse.to_proto$p,
  merge: ListEtpOrgsResponse.merge,
  to_json: ListEtpOrgsResponse.to_json,
  from_json_exn: ListEtpOrgsResponse.from_json_exn,
  from_json: ListEtpOrgsResponse.from_json
};

const listEtpOrgs = [
  listEtpOrgs_0,
  listEtpOrgs_1
];

const listEtpKkms_0 = {
  name: ListEtpKkmsRequest.name,
  make: ListEtpKkmsRequest.make,
  from_proto: ListEtpKkmsRequest.from_proto,
  from_proto_exn: ListEtpKkmsRequest.from_proto_exn,
  to_proto: ListEtpKkmsRequest.to_proto,
  to_proto$p: ListEtpKkmsRequest.to_proto$p,
  merge: ListEtpKkmsRequest.merge,
  to_json: ListEtpKkmsRequest.to_json,
  from_json_exn: ListEtpKkmsRequest.from_json_exn,
  from_json: ListEtpKkmsRequest.from_json
};

const listEtpKkms_1 = {
  name: ListEtpKkmsResponse.name,
  make: ListEtpKkmsResponse.make,
  from_proto: ListEtpKkmsResponse.from_proto,
  from_proto_exn: ListEtpKkmsResponse.from_proto_exn,
  to_proto: ListEtpKkmsResponse.to_proto,
  to_proto$p: ListEtpKkmsResponse.to_proto$p,
  merge: ListEtpKkmsResponse.merge,
  to_json: ListEtpKkmsResponse.to_json,
  from_json_exn: ListEtpKkmsResponse.from_json_exn,
  from_json: ListEtpKkmsResponse.from_json
};

const listEtpKkms = [
  listEtpKkms_0,
  listEtpKkms_1
];

const getEtpInfo_0 = {
  name: GetEtpInfoRequest.name,
  make: GetEtpInfoRequest.make,
  from_proto: GetEtpInfoRequest.from_proto,
  from_proto_exn: GetEtpInfoRequest.from_proto_exn,
  to_proto: GetEtpInfoRequest.to_proto,
  to_proto$p: GetEtpInfoRequest.to_proto$p,
  merge: GetEtpInfoRequest.merge,
  to_json: GetEtpInfoRequest.to_json,
  from_json_exn: GetEtpInfoRequest.from_json_exn,
  from_json: GetEtpInfoRequest.from_json
};

const getEtpInfo_1 = {
  name: GetEtpInfoResponse.name,
  make: GetEtpInfoResponse.make,
  from_proto: GetEtpInfoResponse.from_proto,
  from_proto_exn: GetEtpInfoResponse.from_proto_exn,
  to_proto: GetEtpInfoResponse.to_proto,
  to_proto$p: GetEtpInfoResponse.to_proto$p,
  merge: GetEtpInfoResponse.merge,
  to_json: GetEtpInfoResponse.to_json,
  from_json_exn: GetEtpInfoResponse.from_json_exn,
  from_json: GetEtpInfoResponse.from_json
};

const getEtpInfo = [
  getEtpInfo_0,
  getEtpInfo_1
];

const getEtpLink_0 = {
  name: GetEtpLinkRequest.name,
  make: GetEtpLinkRequest.make,
  from_proto: GetEtpLinkRequest.from_proto,
  from_proto_exn: GetEtpLinkRequest.from_proto_exn,
  to_proto: GetEtpLinkRequest.to_proto,
  to_proto$p: GetEtpLinkRequest.to_proto$p,
  merge: GetEtpLinkRequest.merge,
  to_json: GetEtpLinkRequest.to_json,
  from_json_exn: GetEtpLinkRequest.from_json_exn,
  from_json: GetEtpLinkRequest.from_json
};

const getEtpLink_1 = {
  name: GetEtpLinkResponse.name,
  make: GetEtpLinkResponse.make,
  from_proto: GetEtpLinkResponse.from_proto,
  from_proto_exn: GetEtpLinkResponse.from_proto_exn,
  to_proto: GetEtpLinkResponse.to_proto,
  to_proto$p: GetEtpLinkResponse.to_proto$p,
  merge: GetEtpLinkResponse.merge,
  to_json: GetEtpLinkResponse.to_json,
  from_json_exn: GetEtpLinkResponse.from_json_exn,
  from_json: GetEtpLinkResponse.from_json
};

const getEtpLink = [
  getEtpLink_0,
  getEtpLink_1
];

const createEtpLink_0 = {
  name: CreateEtpLinkRequest.name,
  make: CreateEtpLinkRequest.make,
  from_proto: CreateEtpLinkRequest.from_proto,
  from_proto_exn: CreateEtpLinkRequest.from_proto_exn,
  to_proto: CreateEtpLinkRequest.to_proto,
  to_proto$p: CreateEtpLinkRequest.to_proto$p,
  merge: CreateEtpLinkRequest.merge,
  to_json: CreateEtpLinkRequest.to_json,
  from_json_exn: CreateEtpLinkRequest.from_json_exn,
  from_json: CreateEtpLinkRequest.from_json
};

const createEtpLink_1 = {
  name: CreateEtpLinkResponse.name,
  make: CreateEtpLinkResponse.make,
  from_proto: CreateEtpLinkResponse.from_proto,
  from_proto_exn: CreateEtpLinkResponse.from_proto_exn,
  to_proto: CreateEtpLinkResponse.to_proto,
  to_proto$p: CreateEtpLinkResponse.to_proto$p,
  merge: CreateEtpLinkResponse.merge,
  to_json: CreateEtpLinkResponse.to_json,
  from_json_exn: CreateEtpLinkResponse.from_json_exn,
  from_json: CreateEtpLinkResponse.from_json
};

const createEtpLink = [
  createEtpLink_0,
  createEtpLink_1
];

const updateEtpLink_0 = {
  name: UpdateEtpLinkRequest.name,
  make: UpdateEtpLinkRequest.make,
  from_proto: UpdateEtpLinkRequest.from_proto,
  from_proto_exn: UpdateEtpLinkRequest.from_proto_exn,
  to_proto: UpdateEtpLinkRequest.to_proto,
  to_proto$p: UpdateEtpLinkRequest.to_proto$p,
  merge: UpdateEtpLinkRequest.merge,
  to_json: UpdateEtpLinkRequest.to_json,
  from_json_exn: UpdateEtpLinkRequest.from_json_exn,
  from_json: UpdateEtpLinkRequest.from_json
};

const updateEtpLink_1 = {
  name: UpdateEtpLinkResponse.name,
  make: UpdateEtpLinkResponse.make,
  from_proto: UpdateEtpLinkResponse.from_proto,
  from_proto_exn: UpdateEtpLinkResponse.from_proto_exn,
  to_proto: UpdateEtpLinkResponse.to_proto,
  to_proto$p: UpdateEtpLinkResponse.to_proto$p,
  merge: UpdateEtpLinkResponse.merge,
  to_json: UpdateEtpLinkResponse.to_json,
  from_json_exn: UpdateEtpLinkResponse.from_json_exn,
  from_json: UpdateEtpLinkResponse.from_json
};

const updateEtpLink = [
  updateEtpLink_0,
  updateEtpLink_1
];

const resetEtpLink_0 = {
  name: ResetEtpLinkRequest.name,
  make: ResetEtpLinkRequest.make,
  from_proto: ResetEtpLinkRequest.from_proto,
  from_proto_exn: ResetEtpLinkRequest.from_proto_exn,
  to_proto: ResetEtpLinkRequest.to_proto,
  to_proto$p: ResetEtpLinkRequest.to_proto$p,
  merge: ResetEtpLinkRequest.merge,
  to_json: ResetEtpLinkRequest.to_json,
  from_json_exn: ResetEtpLinkRequest.from_json_exn,
  from_json: ResetEtpLinkRequest.from_json
};

const resetEtpLink_1 = {
  name: ResetEtpLinkResponse.name,
  make: ResetEtpLinkResponse.make,
  from_proto: ResetEtpLinkResponse.from_proto,
  from_proto_exn: ResetEtpLinkResponse.from_proto_exn,
  to_proto: ResetEtpLinkResponse.to_proto,
  to_proto$p: ResetEtpLinkResponse.to_proto$p,
  merge: ResetEtpLinkResponse.merge,
  to_json: ResetEtpLinkResponse.to_json,
  from_json_exn: ResetEtpLinkResponse.from_json_exn,
  from_json: ResetEtpLinkResponse.from_json
};

const resetEtpLink = [
  resetEtpLink_0,
  resetEtpLink_1
];

const V1alpha1_KkmEtpService = {
  ListEtpOrgs: {
    name: "/buhta.kassa.v1alpha1.KkmEtpService/ListEtpOrgs",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmEtpService",
    method_name: "ListEtpOrgs",
    $$Request: {
      name: ListEtpOrgsRequest.name,
      make: ListEtpOrgsRequest.make,
      from_proto: ListEtpOrgsRequest.from_proto,
      from_proto_exn: ListEtpOrgsRequest.from_proto_exn,
      to_proto: ListEtpOrgsRequest.to_proto,
      to_proto$p: ListEtpOrgsRequest.to_proto$p,
      merge: ListEtpOrgsRequest.merge,
      to_json: ListEtpOrgsRequest.to_json,
      from_json_exn: ListEtpOrgsRequest.from_json_exn,
      from_json: ListEtpOrgsRequest.from_json
    },
    $$Response: {
      name: ListEtpOrgsResponse.name,
      make: ListEtpOrgsResponse.make,
      from_proto: ListEtpOrgsResponse.from_proto,
      from_proto_exn: ListEtpOrgsResponse.from_proto_exn,
      to_proto: ListEtpOrgsResponse.to_proto,
      to_proto$p: ListEtpOrgsResponse.to_proto$p,
      merge: ListEtpOrgsResponse.merge,
      to_json: ListEtpOrgsResponse.to_json,
      from_json_exn: ListEtpOrgsResponse.from_json_exn,
      from_json: ListEtpOrgsResponse.from_json
    }
  },
  listEtpOrgs: listEtpOrgs,
  ListEtpKkms: {
    name: "/buhta.kassa.v1alpha1.KkmEtpService/ListEtpKkms",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmEtpService",
    method_name: "ListEtpKkms",
    $$Request: {
      name: ListEtpKkmsRequest.name,
      make: ListEtpKkmsRequest.make,
      from_proto: ListEtpKkmsRequest.from_proto,
      from_proto_exn: ListEtpKkmsRequest.from_proto_exn,
      to_proto: ListEtpKkmsRequest.to_proto,
      to_proto$p: ListEtpKkmsRequest.to_proto$p,
      merge: ListEtpKkmsRequest.merge,
      to_json: ListEtpKkmsRequest.to_json,
      from_json_exn: ListEtpKkmsRequest.from_json_exn,
      from_json: ListEtpKkmsRequest.from_json
    },
    $$Response: {
      name: ListEtpKkmsResponse.name,
      make: ListEtpKkmsResponse.make,
      from_proto: ListEtpKkmsResponse.from_proto,
      from_proto_exn: ListEtpKkmsResponse.from_proto_exn,
      to_proto: ListEtpKkmsResponse.to_proto,
      to_proto$p: ListEtpKkmsResponse.to_proto$p,
      merge: ListEtpKkmsResponse.merge,
      to_json: ListEtpKkmsResponse.to_json,
      from_json_exn: ListEtpKkmsResponse.from_json_exn,
      from_json: ListEtpKkmsResponse.from_json
    }
  },
  listEtpKkms: listEtpKkms,
  GetEtpInfo: {
    name: "/buhta.kassa.v1alpha1.KkmEtpService/GetEtpInfo",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmEtpService",
    method_name: "GetEtpInfo",
    $$Request: {
      name: GetEtpInfoRequest.name,
      make: GetEtpInfoRequest.make,
      from_proto: GetEtpInfoRequest.from_proto,
      from_proto_exn: GetEtpInfoRequest.from_proto_exn,
      to_proto: GetEtpInfoRequest.to_proto,
      to_proto$p: GetEtpInfoRequest.to_proto$p,
      merge: GetEtpInfoRequest.merge,
      to_json: GetEtpInfoRequest.to_json,
      from_json_exn: GetEtpInfoRequest.from_json_exn,
      from_json: GetEtpInfoRequest.from_json
    },
    $$Response: {
      name: GetEtpInfoResponse.name,
      make: GetEtpInfoResponse.make,
      from_proto: GetEtpInfoResponse.from_proto,
      from_proto_exn: GetEtpInfoResponse.from_proto_exn,
      to_proto: GetEtpInfoResponse.to_proto,
      to_proto$p: GetEtpInfoResponse.to_proto$p,
      merge: GetEtpInfoResponse.merge,
      to_json: GetEtpInfoResponse.to_json,
      from_json_exn: GetEtpInfoResponse.from_json_exn,
      from_json: GetEtpInfoResponse.from_json
    }
  },
  getEtpInfo: getEtpInfo,
  GetEtpLink: {
    name: "/buhta.kassa.v1alpha1.KkmEtpService/GetEtpLink",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmEtpService",
    method_name: "GetEtpLink",
    $$Request: {
      name: GetEtpLinkRequest.name,
      make: GetEtpLinkRequest.make,
      from_proto: GetEtpLinkRequest.from_proto,
      from_proto_exn: GetEtpLinkRequest.from_proto_exn,
      to_proto: GetEtpLinkRequest.to_proto,
      to_proto$p: GetEtpLinkRequest.to_proto$p,
      merge: GetEtpLinkRequest.merge,
      to_json: GetEtpLinkRequest.to_json,
      from_json_exn: GetEtpLinkRequest.from_json_exn,
      from_json: GetEtpLinkRequest.from_json
    },
    $$Response: {
      name: GetEtpLinkResponse.name,
      make: GetEtpLinkResponse.make,
      from_proto: GetEtpLinkResponse.from_proto,
      from_proto_exn: GetEtpLinkResponse.from_proto_exn,
      to_proto: GetEtpLinkResponse.to_proto,
      to_proto$p: GetEtpLinkResponse.to_proto$p,
      merge: GetEtpLinkResponse.merge,
      to_json: GetEtpLinkResponse.to_json,
      from_json_exn: GetEtpLinkResponse.from_json_exn,
      from_json: GetEtpLinkResponse.from_json
    }
  },
  getEtpLink: getEtpLink,
  CreateEtpLink: {
    name: "/buhta.kassa.v1alpha1.KkmEtpService/CreateEtpLink",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmEtpService",
    method_name: "CreateEtpLink",
    $$Request: {
      name: CreateEtpLinkRequest.name,
      make: CreateEtpLinkRequest.make,
      from_proto: CreateEtpLinkRequest.from_proto,
      from_proto_exn: CreateEtpLinkRequest.from_proto_exn,
      to_proto: CreateEtpLinkRequest.to_proto,
      to_proto$p: CreateEtpLinkRequest.to_proto$p,
      merge: CreateEtpLinkRequest.merge,
      to_json: CreateEtpLinkRequest.to_json,
      from_json_exn: CreateEtpLinkRequest.from_json_exn,
      from_json: CreateEtpLinkRequest.from_json
    },
    $$Response: {
      name: CreateEtpLinkResponse.name,
      make: CreateEtpLinkResponse.make,
      from_proto: CreateEtpLinkResponse.from_proto,
      from_proto_exn: CreateEtpLinkResponse.from_proto_exn,
      to_proto: CreateEtpLinkResponse.to_proto,
      to_proto$p: CreateEtpLinkResponse.to_proto$p,
      merge: CreateEtpLinkResponse.merge,
      to_json: CreateEtpLinkResponse.to_json,
      from_json_exn: CreateEtpLinkResponse.from_json_exn,
      from_json: CreateEtpLinkResponse.from_json
    }
  },
  createEtpLink: createEtpLink,
  UpdateEtpLink: {
    name: "/buhta.kassa.v1alpha1.KkmEtpService/UpdateEtpLink",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmEtpService",
    method_name: "UpdateEtpLink",
    $$Request: {
      name: UpdateEtpLinkRequest.name,
      make: UpdateEtpLinkRequest.make,
      from_proto: UpdateEtpLinkRequest.from_proto,
      from_proto_exn: UpdateEtpLinkRequest.from_proto_exn,
      to_proto: UpdateEtpLinkRequest.to_proto,
      to_proto$p: UpdateEtpLinkRequest.to_proto$p,
      merge: UpdateEtpLinkRequest.merge,
      to_json: UpdateEtpLinkRequest.to_json,
      from_json_exn: UpdateEtpLinkRequest.from_json_exn,
      from_json: UpdateEtpLinkRequest.from_json
    },
    $$Response: {
      name: UpdateEtpLinkResponse.name,
      make: UpdateEtpLinkResponse.make,
      from_proto: UpdateEtpLinkResponse.from_proto,
      from_proto_exn: UpdateEtpLinkResponse.from_proto_exn,
      to_proto: UpdateEtpLinkResponse.to_proto,
      to_proto$p: UpdateEtpLinkResponse.to_proto$p,
      merge: UpdateEtpLinkResponse.merge,
      to_json: UpdateEtpLinkResponse.to_json,
      from_json_exn: UpdateEtpLinkResponse.from_json_exn,
      from_json: UpdateEtpLinkResponse.from_json
    }
  },
  updateEtpLink: updateEtpLink,
  ResetEtpLink: {
    name: "/buhta.kassa.v1alpha1.KkmEtpService/ResetEtpLink",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "KkmEtpService",
    method_name: "ResetEtpLink",
    $$Request: {
      name: ResetEtpLinkRequest.name,
      make: ResetEtpLinkRequest.make,
      from_proto: ResetEtpLinkRequest.from_proto,
      from_proto_exn: ResetEtpLinkRequest.from_proto_exn,
      to_proto: ResetEtpLinkRequest.to_proto,
      to_proto$p: ResetEtpLinkRequest.to_proto$p,
      merge: ResetEtpLinkRequest.merge,
      to_json: ResetEtpLinkRequest.to_json,
      from_json_exn: ResetEtpLinkRequest.from_json_exn,
      from_json: ResetEtpLinkRequest.from_json
    },
    $$Response: {
      name: ResetEtpLinkResponse.name,
      make: ResetEtpLinkResponse.make,
      from_proto: ResetEtpLinkResponse.from_proto,
      from_proto_exn: ResetEtpLinkResponse.from_proto_exn,
      to_proto: ResetEtpLinkResponse.to_proto,
      to_proto$p: ResetEtpLinkResponse.to_proto$p,
      merge: ResetEtpLinkResponse.merge,
      to_json: ResetEtpLinkResponse.to_json,
      from_json_exn: ResetEtpLinkResponse.from_json_exn,
      from_json: ResetEtpLinkResponse.from_json
    }
  },
  resetEtpLink: resetEtpLink
};

const V1alpha1 = {
  ListEtpOrgsRequest: ListEtpOrgsRequest,
  ListEtpOrgsResponse: ListEtpOrgsResponse,
  ListEtpKkmsRequest: ListEtpKkmsRequest,
  ListEtpKkmsResponse: ListEtpKkmsResponse,
  GetEtpInfoRequest: GetEtpInfoRequest,
  GetEtpInfoResponse: GetEtpInfoResponse,
  GetEtpLinkRequest: GetEtpLinkRequest,
  GetEtpLinkResponse: GetEtpLinkResponse,
  CreateEtpLinkRequest: CreateEtpLinkRequest,
  CreateEtpLinkResponse: CreateEtpLinkResponse,
  UpdateEtpLinkRequest: UpdateEtpLinkRequest,
  UpdateEtpLinkResponse: UpdateEtpLinkResponse,
  ResetEtpLinkRequest: ResetEtpLinkRequest,
  ResetEtpLinkResponse: ResetEtpLinkResponse,
  KkmEtpService: V1alpha1_KkmEtpService
};

const Kassa = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Kassa: Kassa
};

export {
  Imported$pmodules,
  Buhta,
}
/* ListEtpOrgsRequest Not a pure module */
